import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import Routes from "./Routes";

function App(): JSX.Element {
  const queryClient = new QueryClient();

  useEffect(() => {
    // if (process.env.NODE_ENV === "development") {
    //   window.localStorage.setItem("userId", "5");
    //   window.localStorage.setItem("doctorId", "6");
    // }
    return () => {};
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        {/* <HeaderSection /> */}
        <Routes />

        {/* <Dashboard /> */}

        {/* <Signup /> */}
      </div>
    </QueryClientProvider>
  );
}

export default App;
